module.exports = __webpack_public_path__ + "static/caincutoutshadow2bs-daacb021041b856b2512bb86cd808525.png";